// Pasting and operating on these lists within other jsx files was becoming unwieldy

// Basic nav list
const navListBase = [
    {
        url: "/Home",
        text: "Home",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/ProfileLanding",
        text: "My Profile",
        target: "",
        classes: "",
        scope: "internal",
        children: [
            {
                url: "/Profile/Info",
                text: "Personal Information",
                target: "_self",
                classes: "",
                scope: "internal",
            },
            {
                url: "/Profile/contacts",
                text: "Emergency Contacts",
                target: "_self",
                classes: "",
                scope: "internal",
            },
        ],
    },
    {
        url: "/Payslips",
        text: "Payslips",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/TaxStatements",
        text: "Tax Statements",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/Payroll/StayBenefit",
        text: "Stay Benefit",
        target: "_self",
        classes: "",
        scope: "internal",
    },
];

const navProfilePlates =
    {
        url: "/Profile/Plates",
        text: "License Plates",
        target: "_self",
        classes: "",
        scope: "internal",
    }

const navSkills = { 
    url: "/SkillsLanding",
    text: "Skills & Experience",
    target: "",
    classes: "",
    scope: "internal",
}

const navSkillPages = [
    {
        url: "/Skills/education",
        text: "Education & Training",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/Skills/certifications",
        text: "Certifications",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/Skills/employment",
        text: "Employment History",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/Skills/community",
        text: "Community Involvement",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/Skills/media",
        text: "Media Relations",
        target: "_self",
        classes: "",
        scope: "internal",
    },
    {
        url: "/Skills/awards",
        text: "Awards & Achievements",
        target: "_self",
        classes: "",
        scope: "internal",
    }
]

const navPreviousProjects = 
{
    url: "/Skills/previousProjects",
    text: "Previous Project Experience",
    target: "_self",
    classes: "",
    scope: "internal",
}

const tabDetailSlim = [
    {
        displayName: "Education & Training",
        key: "education",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Certifications",
        key: "certifications",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Employment History",
        key: "employment",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Community Involvement",
        key: "community",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Media Relations",
        key: "media",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Awards & Achievements",
        key: "awards",
        disabled: false,
        completed: false,
    },
];

const tabDetailFull = [
    {
        displayName: "Education & Training",
        key: "education",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Certifications",
        key: "certifications",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Employment History",
        key: "employment",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Community Involvement",
        key: "community",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Media Relations",
        key: "media",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Awards & Achievements",
        key: "awards",
        disabled: false,
        completed: false,
    },
    {
        displayName: "Previous Project Experience",
        key: "previousProjects",
        disabled: false,
        completed: false,
    },
];

const stepperSlim = [
    "Education & Training",
    "Certifications",
    "Employment History",
    "Community Involvement",
    "Media Relations",
    "Awards & Achievements",
];

const stepperFull = [
    "Education & Training",
    "Certifications",
    "Employment History",
    "Community Involvement",
    "Media Relations",
    "Awards & Achievements",
    "Previous Project Experience",
];

export {
    navListBase,
    navSkills,
    navSkillPages,
    navPreviousProjects,
    navProfilePlates,
    tabDetailSlim,
    tabDetailFull,
    stepperSlim,
    stepperFull
};
